@if (accessRequest$ | async; as result) {
  @if (result.isSuccess) {
    @if (grantedNow) {
      <h1>{{ 'CALLS.ACCESS_REQUEST.GRANTED' | translate }}</h1>
    } @else if (result.data.accessProvided) {
      <h1>{{ 'CALLS.ACCESS_REQUEST.ALREADY_GRANTED' | translate }}</h1>
    }
  } @else if (result.isLoading) {
    <app-spinner></app-spinner>
  } @else if (result.isError) {
    <p>{{ 'COMMON.ERROR_LOADING_DATA' | translate }}</p>
  }
}
